import { Helmet } from 'react-helmet-async';
import ServicePage from './ServicePage';
import { useService } from '../hooks/usePublicApi';
import { serviceCategories } from '../data/services';

const staticData = serviceCategories.find((s) => s.id === 'sanierung');

export default function Sanierung() {
  const { service } = useService('sanierung');
  const data = service || staticData;

  return (
    <>
      <Helmet>
        <title>Sanierung & Renovierung | Süd Ausbau GmbH</title>
        <meta name="description" content="Fachgerechte Sanierung und Renovierung in München. Altbausanierung, Wasserschadensanierung und energetische Modernisierung — Süd Ausbau GmbH." />
      </Helmet>
      <ServicePage data={data} />
    </>
  );
}
